import React from "react";
import Typewriter from "typewriter-effect";
import { headlines } from "../../data/resume";

function Type() {
  return (
    <Typewriter
      options={{
        strings: headlines,
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
